import React from 'react'
import { TransactionSearchField, utils } from '@adc/ui-core'

/* istanbul ignore next */
const field = fieldProps => <TransactionSearchField compact {...fieldProps} />

const { GRAPH_API_FRAGMENT_DEFINITION, GRAPH_API_FRAGMENT_REFERENCE } =
  utils.symbols
field[GRAPH_API_FRAGMENT_DEFINITION] =
  TransactionSearchField[GRAPH_API_FRAGMENT_DEFINITION]
field[GRAPH_API_FRAGMENT_REFERENCE] =
  TransactionSearchField[GRAPH_API_FRAGMENT_REFERENCE]

export default field
